import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=2971d01a&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=2971d01a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971d01a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2971d01a')) {
      api.createRecord('2971d01a', component.options)
    } else {
      api.reload('2971d01a', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=2971d01a&scoped=true&", function () {
      api.rerender('2971d01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2asVt7o4xF28k/JS/comp/DateRangeExt.vue"
export default component.exports